import { Component, OnDestroy, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { User } from '../_models';
import { UserInfo } from '../_models/user-info';
import { MessService } from '../_services/mess-service.service';
import { UsersService } from '../_services/users.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
})
export class UsersComponent implements OnInit, OnDestroy {
  users: User[];
  loading: boolean = true;

  usersTypes = [
    { label: 'Aktivni korisnici', value: 'active' },
    { label: 'Obrisani korisnici', value: 'deleted' },
  ];

  subscriptions: Subscription[] = [];

  constructor(
    private confirmationService: ConfirmationService,
    private messService: MessService,
    private usersService: UsersService
  ) {}

  // * Lifecycles === //
  ngOnInit(): void {
    this.updateUsersList();
    this.getDeletedUsersList();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  // * Delete user === //
  onDeleteUser($event: Event, userId: number) {
    this.confirmationService.confirm({
      target: event.target,
      message: 'Da li ste sigurni da želite da obrišete korisnika?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.subscriptions.push(
          this.usersService.deleteUser(userId).subscribe(
            () => {
              this.messService.add({
                severity: 'success',
                title: 'Uspešno brisanje',
                detail: 'Obrisali ste korisnika.',
              });
              this.updateUsersList();
            },
            (error) => {
              this.messService.add({
                severity: 'error',
                title: 'Greška',
                detail: 'Došlo je do greške, pokušajte ponovo!',
              });
            }
          )
        );
      },
    });
  }

  // * Edit/Delete === //
  onEditUser(userData: UserInfo) {
    this.usersService.updateUserData.next(userData);
  }

  // * Helpers === //
  updateUsersList() {
    // Get active users
    this.loading = true;
    this.subscriptions.push(
      this.usersService.getAllUsers().subscribe((users) => {
        this.users = users;
        this.loading = false;
      })
    );
  }

  getDeletedUsersList() {
    // Get deleted users
    this.loading = true;
    this.subscriptions.push(
      this.usersService.getAllDeletedUsers().subscribe((deletedUsers) => {
        this.users = deletedUsers;
        this.loading = false;
      })
    );
  }

  onChangeUsersType(usersType) {
    if (usersType === 'active') {
      this.updateUsersList();
    } else {
      this.getDeletedUsersList();
    }
  }
}
